import { render, staticRenderFns } from "./moreTop.vue?vue&type=template&id=d6dd0b64&lang=pug&"
import script from "./moreTop.vue?vue&type=script&lang=js&"
export * from "./moreTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports